import React, { useState, useEffect, memo, Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
import Radio from '@material-ui/core/Radio';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import Skeleton from '@material-ui/lab/Skeleton';

import useApi from 'app/context/useApi';

const useStyles = makeStyles(theme => ({
    root: {
        height: '100%'
    },
    subHeader: {
        backgroundColor: theme.palette.grey[200],
        zIndex: '10'
    },
    empty: {
        textAlign: 'center',
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        paddingTop: theme.spacing(9),
        paddingBottom: theme.spacing(9)
    }
}));

export default function SimpleSelect(props) {

    const classes = useStyles();
    const api = useApi();

    const [ loading, setLoading ] = useState(false);
    const [ groupOptions, setGroupOptions ] = useState([]);
    const [ selectedId, setSelectedId ] = useState(0)
    const {
        initSelectedId,
        initGroupOptions,
        unselectableId,
        onSelect,
        optionsLoading,
        color
    } = props;

    useEffect(() => {
        setSelectedId((initSelectedId || 0));
    }, [initSelectedId]);

    const getGroupOptions = () => {
        setLoading(true);

        api.get('/group')
            .then(res => {
                setGroupOptions(res.groups);
            }).catch( error => {
                //console.log(error);
            }).then(() => setLoading(false));
    };

    useEffect(() => {
        if (initGroupOptions) {
            setGroupOptions(initGroupOptions)
        } else {
            getGroupOptions();
        }
    }, [initGroupOptions]);

    useEffect(() => {
        setLoading(optionsLoading);
    }, [optionsLoading])

    const handleSelect = id => {
        if (id !== unselectableId) {
            if (id == selectedId) {
                setSelectedId(0);
                onSelect(0);
            } else {
                setSelectedId(id)
                onSelect(id);
            }
        }
    }

    return (
        <List
            dense
            aria-labelledby="group-select"
            className={classes.root}
            >
            {loading ? (
                <Fragment>
                    <ListItem>
                        <ListItemText disableTypography
                            primary={<Skeleton variant="text" height={6} width="40%"/>}
                            secondary={<Skeleton variant="text" height={6} width="80%"/>}
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText disableTypography
                            primary={<Skeleton variant="text" height={6} width="50%"/>}
                            secondary={<Skeleton variant="text" height={6} width="40%"/>}
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText disableTypography
                            primary={<Skeleton variant="text" height={6} width="20%"/>}
                            secondary={<Skeleton variant="text" height={6} width="70%"/>}
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText disableTypography
                            primary={<Skeleton variant="text" height={6} width="60%"/>}
                            secondary={<Skeleton variant="text" height={6} width="50%"/>}
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText disableTypography
                            primary={<Skeleton variant="text" height={6} width="30%"/>}
                            secondary={<Skeleton variant="text" height={6} width="50%"/>}
                        />
                    </ListItem>
                </Fragment>

            ) : (
                <Fragment>
                    <ListItem key={0} dense button onClick={() => handleSelect(0)}>
                        <ListItemIcon>
                            <Radio
                                checked={selectedId === 0}
                                value={0}
                                name={'club'}
                                inputProps={{ 'aria-labelledby': 'group-select-club' }}
                                color={color ?? "secondary"}
                                />
                        </ListItemIcon>
                        <ListItemText id={'group-select-club'} primary='Entire Club' />
                    </ListItem>

                    {groupOptions.map((group) => (
                        <ListItem key={group.id} dense button onClick={() => handleSelect(group.id)}>
                            <ListItemIcon>
                                <Radio
                                    checked={selectedId === group.id}
                                    value={group.id}
                                    name={group.title}
                                    inputProps={{ 'aria-labelledby': 'group-select-' + group.id }}
                                    color={color ?? "secondary"}
                                    />
                            </ListItemIcon>
                            <ListItemText id={'group-select-' + group.id} primary={group.title} />
                        </ListItem>
                    ))}
                </Fragment>
            )}
        </List>
    )
}
